import { toast as sonnerToast } from "sonner";

import { shouldSuppressToast } from "@/utils/constant/suppressedMessages";

type SonnerToast = typeof sonnerToast;

/**
 * Drop-in replacement for sonner's `toast` that silently swallows generic /
 * suppressed error messages (see `suppressedMessages`). All other behaviour is
 * identical to sonner, so `toast`, `toast.success`, `toast.promise`, etc. keep
 * working the same way across the app.
 */
const error: SonnerToast["error"] = (message, data) => {
  if (typeof message === "string" && shouldSuppressToast(message)) {
    return "" as ReturnType<SonnerToast["error"]>;
  }
  return sonnerToast.error(message, data);
};

export const toast: SonnerToast = Object.assign(
  ((...args: Parameters<SonnerToast>) =>
    sonnerToast(...args)) as SonnerToast,
  sonnerToast,
  { error }
);
